import { all, takeLatest } from 'lib/redux';
import { LOAD_REPORTS_CHANGE_PAGE } from 'constants/ActionTypes';
import loadReportsChangeSaga from './ReportsChange.saga';

/**
 * Defines the watchers related to ReportsChange Page.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(LOAD_REPORTS_CHANGE_PAGE, loadReportsChangeSaga),
  ]);
}
